import React, { Component } from 'react';
import { Provider } from 'react-redux'
import configureStore from './actions/store'
import {
  BrowserRouter as Router,
  Route
} from "react-router-dom";
import LoginLayout from "./layouts/LoginLayout";
import AdminLoginLayout from "./layouts/AdminLoginLayout";
import MainLayout from "./layouts/MainLayout";
import AdminLayout from "./layouts/AdminLayout";
import UserLayout from "./layouts/UserLayout";
import AgentLayout from './layouts/AgentLayout';
import OmsgReportLayout from './layouts/OmsgReportLayout';
import XIVodafoneLayout from './layouts/XIVodafoneLayout';

export const store = configureStore();

class App extends Component {
  
  render() {
    
    return (
      <Provider store={store}>
        <Router>
          <MainLayout>
            <Route exact path="/" component={LoginLayout} />
            <Route path="/admin-login" component={AdminLoginLayout} />
            <Route path="/admin" component={AdminLayout} />
            <Route path="/account-activated" component={LoginLayout} />
            <Route path="/sms-verified" component={LoginLayout} />
            <Route path="/agent" component={AgentLayout} />
            <Route path="/user" component={UserLayout} />
            <Route path="/omsg-report" component={OmsgReportLayout} />
            <Route path="/xivodafone" component={XIVodafoneLayout} />
          </MainLayout>
        </Router>
      </Provider>
    );
  }
}

export default App;
